import React, { Component, createRef } from "react";
import { notify } from "react-notify-toast";
import Header from "../components/header";
import db from "../firebase";
import download from "../assets/icons/download.png";
import del from "../assets/icons/delete.png";
export default class DocumentsUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tradeLicense: null,
      taxCertificate: null,
      bankDetails: null,
      secondaryEmail: "",
      secondaryPhone: "",
      primaryEmail: "",
      primaryPhone: "",
      ifsc: "",
      bankName: "",
      accountHolderName: "",
      accountNumber: "",
    };
  }
  tradeInput = createRef();
  licenseInput = createRef();
  async componentDidMount() {
    let data = await db
      .collection("Merchant")
      .doc(JSON.parse(localStorage.getItem("Ubytes")).uid)
      .get();
    this.setState(data.data());
  }
  updateBank = async () => {
    let { bankName, accountHolderName, accountNumber, ifsc } = this.state;
    if (
      bankName === "" ||
      accountHolderName === "" ||
      accountNumber === "" ||
      ifsc === ""
    ) {
      notify.show("Please fill all fields in Bank section", "warning");
      return;
    }
    await db
      .collection("Merchant")
      .doc(JSON.parse(localStorage.getItem("Ubytes")).uid)
      .update({
        ifsc: ifsc,
        bankName: bankName,
        accountNumber: accountNumber,
        accountHolderName: accountHolderName,
      });
    notify.show("Bank Details updated Successfully", "success");
  };
  updateContact = async () => {
    let {
      primaryEmail,
      primaryPhone,
      secondaryEmail,
      secondaryPhone,
    } = this.state;
    if (
      primaryEmail === "" ||
      primaryPhone === "" ||
      secondaryEmail === "" ||
      secondaryPhone === ""
    ) {
      notify.show("Fill all fields in Contact section", "warning");
      return;
    }
    await db
      .collection("Merchant")
      .doc(JSON.parse(localStorage.getItem("Ubytes")).uid)
      .update({
        primaryEmail: primaryEmail,
        primaryPhone: primaryPhone,
        secondaryEmail: secondaryEmail,
        secondaryPhone: secondaryPhone,
      });
    notify.show("Contact Updated Details Successfully", "success");
  };

  updateTax = async () => {};
  updateTradeLicense = async () => {};
  downloadTax = () => {};
  deleteTax = () => {};
  downloadLicense = () => {};
  deleteLicense = () => {};
  render() {
    return (
      <div className="doc-body">
        <Header page="Documents"></Header>
        <div className="doc-row">
          <p>Trade License upload:</p>
          <br></br>
          <small>
            1. What is a Trade License? <br></br>A trade license is a
            document/certificate that gives the permission to the applicant
            (person seeking to open a business) to commence a particular trade
            or business in a particular area/location. However, the license does
            not allow the holder to any other trade or business than for it is
            issued. Furthermore, this license does not pass on any kind of
            property ownership to the holder of the license.<br></br> 2. Why
            Trade License? <br></br>In the last forty years, trade license has
            been introduced in the country and is being regulated through
            municipal corporation acts by the state governments. This helps in
            ensuring that no one is severally affected by nuisance and health
            hazard of any trade or business. It has been made necessary by the
            government to carry out any particular business or trade in a
            particular area and to ensure that no one is carrying out any
            unethical business practices. This license creates a harmony in the
            society that every business is following relevant rules, guidelines
            and obeying the safety measures. This license was made obligatory to
            make sure that the government can regulate various trade activities
            in the country. The core objective of issuing a this is to control
            the locations by restricting the people from executing certain types
            of businesses from their home location to maintain the business
            environment and locality environment.
          </small>
          {!this.state.tradeLicense ? (
            <button onClick={() => this.licenseInput.current.click()}>
              Upload{" "}
              <input
                ref={this.licenseInput}
                onChange={(e) =>
                  this.setState({ tradeLicense: e.target.files[0] })
                }
                type="file"
                hidden
              ></input>
            </button>
          ) : (
            <div
              className="doc-uploaded"
              onMouseOver={() => this.setState({ hover: "trade" })}
              onMouseLeave={() => this.setState({ hover: null })}
            >
              {this.state.hover === "trade" ? (
                <>
                  <img onClick={this.downloadLicense} src={download}></img>
                  <img onClick={this.deleteLicense} src={del}></img>
                </>
              ) : (
                this.state.tradeLicense.name
              )}
            </div>
          )}
        </div>
        <div className="doc-row">
          <p>Tax certificate :</p>
          <br></br>
          <small>
            1. What is a Trade License? <br></br>A trade license is a
            document/certificate that gives the permission to the applicant
            (person seeking to open a business) to commence a particular trade
            or business in a particular area/location. However, the license does
            not allow the holder to any other trade or business than for it is
            issued. Furthermore, this license does not pass on any kind of
            property ownership to the holder of the license.<br></br> 2. Why
            Trade License? <br></br>In the last forty years, trade license has
            been introduced in the country and is being regulated through
            municipal corporation acts by the state governments. This helps in
            ensuring that no one is severally affected by nuisance and health
            hazard of any trade or business. It has been made necessary by the
            government to carry out any particular business or trade in a
            particular area and to ensure that no one is carrying out any
            unethical business practices. This license creates a harmony in the
            society that every business is following relevant rules, guidelines
            and obeying the safety measures. This license was made obligatory to
            make sure that the government can regulate various trade activities
            in the country. The core objective of issuing a this is to control
            the locations by restricting the people from executing certain types
            of businesses from their home location to maintain the business
            environment and locality environment.
          </small>
          {!this.state.taxCertificate ? (
            <button onClick={() => this.tradeInput.current.click()}>
              Upload{" "}
              <input
                ref={this.tradeInput}
                onChange={(e) =>
                  this.setState({ taxCertificate: e.target.files[0] })
                }
                type="file"
                hidden
              ></input>
            </button>
          ) : (
            <div
              className="doc-uploaded"
              onMouseOver={() => this.setState({ hover: "tax" })}
              onMouseLeave={() => this.setState({ hover: null })}
            >
              {this.state.hover === "tax" ? (
                <>
                  <img onClick={this.downloadTax} src={download}></img>
                  <img onClick={this.deleteTax} src={del}></img>
                </>
              ) : (
                this.state.taxCertificate.name
              )}
            </div>
          )}
        </div>
        <div className="doc-row" style={{ width: "40rem" }}>
          <p>Bank details:</p>
          <br></br>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <div style={{ margin: "1%" }}>
              <small>Bank Name:</small>
              <input
                value={this.state.bankName}
                onChange={(e) => this.setState({ bankName: e.target.value })}
                placeholder="Bank Name"
              ></input>
            </div>
            <div style={{ margin: "1%" }}>
              <small>Account Holder Name:</small>
              <input
                value={this.state.accountHolderName}
                placeholder="Account Holder Name"
                onChange={(e) =>
                  this.setState({ accountHolderName: e.target.value })
                }
              ></input>
            </div>
            <div style={{ margin: "1%" }}>
              <small>Account Number:</small>
              <input
                value={this.state.accountNumber}
                placeholder="Account Number"
                onChange={(e) =>
                  this.setState({ accountNumber: e.target.value })
                }
              ></input>
            </div>
            <div style={{ margin: "1%" }}>
              <small>IFSC code:</small>
              <input
                value={this.state.ifsc}
                placeholder="IFSC code"
                onChange={(e) => this.setState({ ifsc: e.target.value })}
              ></input>
            </div>
          </div>
          <button onClick={this.updateBank}>Update</button>
        </div>
        <div className="doc-row" style={{ width: "40rem" }}>
          <p>Contact:</p>
          <br></br>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <div style={{ margin: "1%" }}>
              <small>Primary Email:</small>
              <input
                value={this.state.primaryEmail}
                onChange={(e) =>
                  this.setState({ primaryEmail: e.target.value })
                }
                placeholder="Primary Email"
              ></input>
            </div>
            <div style={{ margin: "1%" }}>
              <small>Primary Phone:</small>
              <input
                value={this.state.primaryPhone}
                onChange={(e) =>
                  this.setState({ primaryPhone: e.target.value })
                }
                placeholder="Primary Phone"
              ></input>
            </div>
            <div style={{ margin: "1%" }}>
              <small>Secondary Email:</small>
              <input
                value={this.state.secondaryEmail}
                onChange={(e) =>
                  this.setState({ secondaryEmail: e.target.value })
                }
                placeholder="Secondary Email"
              ></input>
            </div>
            <div style={{ margin: "1%" }}>
              <small>Secondary Phone:</small>
              <input
                value={this.state.secondaryPhone}
                onChange={(e) =>
                  this.setState({ secondaryPhone: e.target.value })
                }
                placeholder="Secondary Phone"
              ></input>
            </div>
          </div>
          <button onClick={this.updateContact}>Update</button>
        </div>
      </div>
    );
  }
}
